<template>
	<li class="wards__item">
		<strong>{{ item.name }}</strong>, {{ item.email }}
		<br>
		<small><span>Дата регистрации:</span> {{ item.created_at }}</small>
		<div class="wards__more" @click="opened = !opened">
			<i uk-icon="info" uk-tooltip="Подробнее о пользователе"></i>
		</div>
		<wardFull v-if="opened" :item="item" @closeFullWard="closeFullWard"></wardFull>
	</li>
</template>

<script>
	import wardFull from './ward-full'
  export default {
    name: "ward",
	  components: {
      wardFull
	  },
    data() {
      return {
        opened: false
      }
    },
    props: {
      item: ''
    },
    methods: {
      closeFullWard(){
        this.opened = false;
        $('body').removeClass('fixed');
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/ward.vue